import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import Icon from 'components/Icon';
import Tooltip from 'components/Tooltip';
import Wrapper from './styles';
import { jsx as _jsx2 } from "react/jsx-runtime";

var Hint = /*#__PURE__*/function (_PureComponent) {
  _inherits(Hint, _PureComponent);

  var _super = _createSuper(Hint);

  function Hint() {
    var _this;

    _classCallCheck(this, Hint);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      showTooltip: false
    };
    _this.showEvents = ['mouseenter', 'touchend'];
    _this.hideEvents = ['mouseleave'];

    _this.toggleTooltip = function () {
      var isShow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      _this.setState(function (_ref) {
        var showTooltip = _ref.showTooltip;
        return {
          showTooltip: isShow !== null ? isShow : !showTooltip
        };
      });
    };

    _this.handleClickWrapper = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    return _this;
  }

  _createClass(Hint, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          position = _this$props.position,
          children = _this$props.children,
          iconFill = _this$props.iconFill,
          icon = _this$props.icon,
          tooltipProps = _this$props.tooltipProps;
      var showTooltip = this.state.showTooltip;
      return /*#__PURE__*/_jsx(Wrapper, {
        onClick: this.handleClickWrapper,
        "data-tip-target": true
      }, void 0, /*#__PURE__*/_jsx(Icon, {
        name: icon,
        fill: iconFill,
        tabIndex: "0"
      }), /*#__PURE__*/_jsx2(Tooltip, _objectSpread(_objectSpread({
        show: showTooltip,
        position: position,
        toggle: this.toggleTooltip,
        showEvents: this.showEvents,
        hideEvents: this.hideEvents
      }, tooltipProps), {}, {
        children: children
      })));
    }
  }]);

  return Hint;
}(PureComponent);

Hint.defaultProps = {
  iconFill: 'gray',
  children: null,
  icon: 'questionMark',
  tooltipProps: {}
};
export default Hint;